// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SbNOx","disabled":"styles_disabled__1C7_f"};